<common-top-tool-bar
  [title]="editId ? '编辑英语王者级别' : '新增英语王者级别'"
  [back]="'/admin/v3/game/levels'"
  [actionsTemplate]="formActions"
>
  <ng-template #formActions>
    <button nz-button nzType="primary" class="mr-4" nzSize="large" nzGhost [routerLink]="'/admin/v3/game/levels'">
      取消
    </button>
    <button nz-button nzType="primary" nzSize="large" type="button" [nzLoading]="saving" (click)="submit()">
      {{ editId ? '保存' : '确定新增' }}
    </button>
  </ng-template>
</common-top-tool-bar>

<div class="page-tab-main v3">
  <nz-spin [nzSpinning]="loading">
    <div class="page-main">
      <div class="page-main-wrapper game-form-edit-wrapper">
        <form nz-form nzLayout="vertical">
          <div nz-row nzGutter="36">
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzFor="levelCode" nzRequired>级别 code</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input
                    nz-input
                    nzSize="large"
                    id="levelCode"
                    name="levelCode"
                    [(ngModel)]="form.levelCode"
                    maxlength="64"
                    placeholder="全局唯一，最长 64 字符"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzFor="name" nzRequired>级别名</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input
                    nz-input
                    nzSize="large"
                    id="name"
                    name="name"
                    [(ngModel)]="form.name"
                    maxlength="255"
                    placeholder="级别名称"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">卡片图片</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <ng-template #cardImageHintTpl>
                    <div class="p-6">请将文件拖曳至此或点击此处上传图片。</div>
                  </ng-template>
                  <!-- 与习题编辑「上传封面图片」一致：固定宽度 + flex，避免大比例占位层叠覆盖其它表单项 -->
                  <div class="flex flex-wrap items-end gap-4">
                    <app-upload-image-with-preview-v2
                      [picPreview]="true"
                      [innerClass]=""
                      style="width: 180px; display: inline-block;"
                      [displayTextTemplate]="cardImageHintTpl"
                      [displayIcon]="null"
                      [picUrl]="cardImageUrlForPreview"
                      (imageUploaded)="onCardImageUploaded($event)"
                      previewClass="bg-cover bg-center"
                      [displayRatioWidth]="16"
                      [displayRatioHeight]="9"
                      [sizeLimit]="2"
                    ></app-upload-image-with-preview-v2>
                    <div class="font-light text-xs px-2 text-gray-600 max-w-md">
                      注：图片格式为 Jpg 或 Png 文件，图片文件大小限制为 2MB
                    </div>
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzFor="baseScore">每题基础分</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-input-number
                    name="baseScore"
                    id="baseScore"
                    [(ngModel)]="form.baseScore"
                    [nzMin]="0"
                    [nzStep]="1"
                    style="width: 100%"
                  ></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzFor="questionCount">每局随机题数</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-input-number
                    name="questionCount"
                    id="questionCount"
                    [(ngModel)]="form.questionCount"
                    [nzMin]="0"
                    [nzStep]="1"
                    style="width: 100%"
                  ></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzFor="secondPerQuestion">每题选择时间限制（秒）</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-input-number
                    name="secondPerQuestion"
                    id="secondPerQuestion"
                    [(ngModel)]="form.secondPerQuestion"
                    [nzMin]="0"
                    [nzStep]="1"
                    style="width: 100%"
                  ></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzFor="timeBonus">每秒额外分数</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-input-number
                    name="timeBonus"
                    id="timeBonus"
                    [(ngModel)]="form.timeBonus"
                    [nzMin]="0"
                    [nzStep]="1"
                    style="width: 100%"
                  ></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzFor="victoryBonus">胜利额外分数</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-input-number
                    name="victoryBonus"
                    id="victoryBonus"
                    [(ngModel)]="form.victoryBonus"
                    [nzMin]="0"
                    [nzStep]="1"
                    style="width: 100%"
                  ></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzFor="dailyLimit">每日次数上限</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-input-number
                    name="dailyLimit"
                    id="dailyLimit"
                    [(ngModel)]="form.dailyLimit"
                    [nzMin]="0"
                    [nzStep]="1"
                    style="width: 100%"
                  ></nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzFor="status">有效状态</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-switch
                    name="status"
                    id="status"
                    [ngModel]="form.status === GameLevelStatus.ACTIVE"
                    (ngModelChange)="form.status = $event ? GameLevelStatus.ACTIVE : GameLevelStatus.INACTIVE"
                    nzCheckedChildren="有效"
                    nzUnCheckedChildren="无效"
                  ></nz-switch>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzFor="ruleDescription">规则描述</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <textarea
                    nz-input
                    id="ruleDescription"
                    name="ruleDescription"
                    [(ngModel)]="form.ruleDescription"
                    rows="4"
                    placeholder="可选"
                  ></textarea>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </form>
      </div>
    </div>
  </nz-spin>
</div>
